<template>
    <v-fade-transition>
        <div
            v-if="hover || showTooltip"
            class="d-flex transition-fast-in-fast-out text-center ar-tooltip habiteo-body-2"
            :class="{
                'pr-4': !$vuetify.breakpoint.xsOnly,
                'offset px-2': $vuetify.breakpoint.xsOnly
            }"
        >
            <span>
                {{ $t('augmentedReality.tooltips.info') }}
            </span>
        </div>
    </v-fade-transition>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'ArTooltip',
        props: {
            hover: {
                type: Boolean,
                required: true,
            },
        },
        data() {
            return {
                showTooltip: false,
            }
        },
        mounted() {
            this.displayTooltip();
        },
        computed: {
            ...mapGetters([
                'isLocalstorageAvailable'
            ]),
            localStorageKey() {
                return 'ar-tooltip-' + this.$route.query.key;
            },
            nextDisplayDate() {
                return this.isLocalstorageAvailable ? localStorage.getItem(this.localStorageKey) : null;
            }
        },
        methods: {
            toggleTooltip() {
                this.showTooltip = !this.showTooltip;
            },
            displayTooltip() {
                let today = new Date().getTime();
                if (!this.nextDisplayDate || this.nextDisplayDate <= today) {
                    // 30 days between each time the popup is displayed
                    let lifeCycle = 30 * 24 * 60 * 60 * 1000;
                    let nextDate = new Date(new Date().getTime() + lifeCycle);
                    if (this.isLocalstorageAvailable)
                        localStorage.setItem(this.localStorageKey, nextDate.getTime());
                    setTimeout(() => {
                        this.toggleTooltip();
                        // hides the tooltip automatically after 5 seconds
                        setTimeout(() => {
                            this.showTooltip = false
                        }, 5000);
                    }, 1000);
                }
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/augmentedReality/components/ArTooltip.vue